import {
    WAIT_INIT_DEVICE,
    GET_DEVICE_DATA_SUCCESS,
    DISPATCH_DEVICE_AP_SCAN,
    GET_DEVICE_DATA_FAIL,
    SET_DEVICE_DETAIL_DATA,
    GET_DEVICE_DETAIL,
    GET_DEVICE_DETAIL_SUCCESS,
    GET_DEVICE_DETAIL_FAIL,
    ORDER_DEVICE_LIST_SUCCESS,
    DEVICE_STATUS_UPDATED_NOTIFY,
    UPDATE_DEVICE_DETAIL_DATA,
    DO_SAVE_USED_PROFILE,
    DO_SAVE_USED_PROFILE_SUCCESS,
    DO_SAVE_USED_PROFILE_FAIL,

    // abnormal
    SELECT_RESOLVE_DATA,
    SAVE_DEVICE_ABNORMAL_DATA,

    // parameter
    GET_DEVICE_PARAMETER_DATA,

    // ethernet
    GET_DEVICE_ETHERNET,
    GET_DEVICE_ETHERNET_SUCCESS,
    SELECT_DEVICE_ETHERNET,

    // device manager
    DL_DEVICE_CONTROL_CONFIRM,
    GET_DEVICE_NETWORK_INFO,
    GET_DEVICE_NETWORK_INFO_SUCCESS,
    GET_DEVICE_RADIO_INFO,
    GET_DEVICE_RADIO_INFO_SUCCESS,
    GET_DEVICE_VAP_INFO,
    GET_DEVICE_VAP_INFO_SUCCESS,
    DELETE_DEVICE_VAP_INFO,
    DL_DEVICE_CONFIG,
    DL_DEVICE_CONFIG_SUCCESS,
    SELECT_PROFILE_CONFIG_INFO,
    GET_PROFILE_NET_INFO,
    GET_PROFILE_NET_INFO_SUCCESS,
    GET_PROFILE_RADIO_INFO,
    GET_PROFILE_RADIO_INFO_SUCCESS,
    GET_PROFILE_VAP_INFO,
    GET_PROFILE_VAP_INFO_SUCCESS,
    GET_DEVICE_CHECK,
    GET_SELECT_DEVICE,
    DEVICE_CHECK_FIRMWARE,
    DEVICE_FWUPGRADE_ACK,
    DO_DEVICE_SITE_SURVEY,
    DO_DEVICE_SITE_SURVEY_SUCCESS,
    DO_DEVICE_SITE_SURVEY_FAIL,
    GET_DEVICE_SITE_SURVEY_DATA,
    

    // mac white list
    GET_DEVICE_MAC_WHITE_LIST,
    GET_DEVICE_MAC_WHITE_LIST_SUCCESS,
    GET_DEVICE_MAC_WHITE_LIST_FAIL,
    UPDATE_DEVICE_MAC_WHITE_LIST,
    UPDATE_DEVICE_MAC_WHITE_LIST_SUCCESS,
    UPDATE_DEVICE_MAC_WHITE_LIST_FAIL,
    CHECK_IS_EXIST_MAC_WHITE_LIST,
    CHECK_IS_EXIST_MAC_WHITE_LIST_SUCCESS,
    CHECK_IS_EXIST_MAC_WHITE_LIST_FIAL,

    // downlink
    DL_DEVICE_GROUP_CONFIG,
    GET_PROFILE_RADIO_SETTING_INFO_SUCCESS,
    GET_PROFILE_RADIO_SETTING_INFO_FAIL,

    RELOAD_DEVICE_PAGE,

    // switch
    GET_SWITCH_DETAIL_INFO,
    GET_SWITCH_DETAIL_INFO_SUCCESS,
    GET_SWITCH_DETAIL_INFO_FAIL,
    EDIT_SWITCH,
    EDIT_SWITCH_SUCCESS,
    EDIT_SWITCH_FAIL

} from "../actions/device/index";

const doAction = (state, action) => {
    const deviceEthernetList = state.deviceEthernetList;
    let deviceDetail = state.deviceDetail;

    switch (action.type) {
        case WAIT_INIT_DEVICE:
            return {
                ...state,
                status: WAIT_INIT_DEVICE,
                deviceList: [],
                orderList: [],
                deviceDetail: null,
                errMsg: null,
                loading: true,
                popLoading: false
            };
        case GET_DEVICE_DATA_SUCCESS:
            return {
                ...state,
                status: GET_DEVICE_DATA_SUCCESS,
                deviceList: action.params.deviceList,
                deviceStatistic: action.params.deviceStatistic,
                deviceReadyToAdd: action.params.deviceReadyToAdd,
                deviceConnected: action.params.deviceConnected,
                readyToAddServerIp: action.params.readyToAddServerIp,
                readyToAddNewPassword: action.params.readyToAddNewPassword,
                loading: false,
            };
        case DISPATCH_DEVICE_AP_SCAN:
            return {
                ...state,
                status: DISPATCH_DEVICE_AP_SCAN,
                scanStart: action.params.scanStart,
                scanResult: action.params.scanResult,
            };
        case GET_DEVICE_DATA_FAIL:
            return {
                ...state,
                errMsg: action.params.errMsg,
                deviceList: [],
                status: GET_DEVICE_DATA_FAIL,
                loading: true,
            };
        case SET_DEVICE_DETAIL_DATA:
            return {
                ...state,
                status: SET_DEVICE_DETAIL_DATA,
                deviceDetail: action.params.deviceDetail
                // selectTemplate: action.params.selectTemplate
            }
        case GET_DEVICE_DETAIL:
            return {
                ...state,
                status: GET_DEVICE_DETAIL,
                deviceDetail: null,
                errMsg: null,
                popLoading: true
            }
        case GET_DEVICE_DETAIL_SUCCESS:
            return {
                ...state,
                status: GET_DEVICE_DETAIL_SUCCESS,
                deviceDetail: action.params.deviceDetail,
                errMsg: null,
                popLoading: false
            }
        case GET_DEVICE_DETAIL_FAIL:
            return {
                ...state,
                status: GET_DEVICE_DETAIL_FAIL,
                deviceDetail: null,
                errMsg: action.params.errMsg,
                popLoading: false
            }
        case ORDER_DEVICE_LIST_SUCCESS:
            return {
                ...state,
                status: ORDER_DEVICE_LIST_SUCCESS,
                orderList: action.params.orderList,
                loading: false,
            }
        case DEVICE_STATUS_UPDATED_NOTIFY:
            return {
                ...state,
                status: DEVICE_STATUS_UPDATED_NOTIFY,
                deviceStatusUpdatTimestamp: action.params.deviceStatusUpdatTimestamp,
            }   
        case UPDATE_DEVICE_DETAIL_DATA:
            return {
                ...state,
                status: UPDATE_DEVICE_DETAIL_DATA,
                updInfo: action.params.updInfo
            }
        case RELOAD_DEVICE_PAGE:
            return {
                ...state,
                status: RELOAD_DEVICE_PAGE,
                reloadTime: action.params.reloadTime
            };
        
        // abnormal
        case SELECT_RESOLVE_DATA:   
            return {
                ...state,
                status: SELECT_RESOLVE_DATA,
                resolveData: action.params.resolveData
            }
        case SAVE_DEVICE_ABNORMAL_DATA:   
            return {
                ...state,
                status: SAVE_DEVICE_ABNORMAL_DATA,
                saveInfo: action.params.info,
                saveConfirm: action.params.confirm
            }

        // device manager
        case DL_DEVICE_CONTROL_CONFIRM:   
            return {
                ...state,
                status: DL_DEVICE_CONTROL_CONFIRM,
                dlInfo: action.params.info,
                dlConfirm: action.params.confirm
            }
        case GET_DEVICE_NETWORK_INFO:
            return {
                ...state,
                status: GET_DEVICE_NETWORK_INFO,
                deviceNetworkInfo: null
            }
        case GET_DEVICE_NETWORK_INFO_SUCCESS:
            return {
                ...state,
                status: GET_DEVICE_NETWORK_INFO_SUCCESS,
                deviceNetworkInfo: action.params.deviceNetworkInfo
            }
        case GET_DEVICE_RADIO_INFO:
            return {
                ...state,
                status: GET_DEVICE_RADIO_INFO,
                deviceRadioInfo: null
            }
        case GET_DEVICE_RADIO_INFO_SUCCESS:
            return {
                ...state,
                status: GET_DEVICE_RADIO_INFO_SUCCESS,
                deviceRadioInfo: action.params.deviceRadioInfo
            }
        case GET_DEVICE_VAP_INFO:
            return {
                ...state,
                status: GET_DEVICE_VAP_INFO,
                deviceVapInfo: null
            }
        case GET_DEVICE_VAP_INFO_SUCCESS:
            return {
                ...state,
                status: GET_DEVICE_VAP_INFO_SUCCESS,
                deviceVapInfo: action.params.deviceVapInfo
            }
        case DELETE_DEVICE_VAP_INFO:
            return {
                ...state,
                status: DELETE_DEVICE_VAP_INFO,
                deleteVapInfo: action.params.deleteVapInfo
            }
        case SELECT_PROFILE_CONFIG_INFO:
            return {
                ...state,
                status: SELECT_PROFILE_CONFIG_INFO,
                selectProfileName: action.params.profileName
            }
        case GET_PROFILE_NET_INFO:
            return {
                ...state,
                status: GET_PROFILE_NET_INFO,
                profileNetList: null
            }
        case GET_PROFILE_NET_INFO_SUCCESS:
            return {
                ...state,
                status: GET_PROFILE_NET_INFO_SUCCESS,
                profileNetList: action.params.profileNetList
            }
        case GET_PROFILE_RADIO_INFO:
            return {
                ...state,
                status: GET_PROFILE_RADIO_INFO,
                profileRadioList: null
            }
        case GET_PROFILE_RADIO_INFO_SUCCESS:
            return {
                ...state,
                status: GET_PROFILE_RADIO_INFO_SUCCESS,
                profileRadioList: action.params.profileRadioList
            }
        case GET_PROFILE_VAP_INFO:
            return {
                ...state,
                status: GET_PROFILE_VAP_INFO,
                profileVapList: null
            }
        case GET_PROFILE_VAP_INFO_SUCCESS:
            return {
                ...state,
                status: GET_PROFILE_VAP_INFO_SUCCESS,
                profileVapList: action.params.profileVapList
            }
        case DL_DEVICE_CONFIG:   
            return {
                ...state,
                status: DL_DEVICE_CONFIG
            }
        case DL_DEVICE_CONFIG_SUCCESS:   
            return {
                ...state,
                status: DL_DEVICE_CONFIG_SUCCESS
            }
        case GET_DEVICE_CHECK:   
            return {
                ...state,
                checkDevice: action.params.checkDevice,
                chooseDevice: action.params.chooseDevice, 
                status: GET_DEVICE_CHECK
            }
        case GET_SELECT_DEVICE:   
            return {
                ...state,
                selectedDevice: action.params.selectedDevice, 
                status: GET_SELECT_DEVICE
            }
        case DEVICE_CHECK_FIRMWARE:
            return {
                ...state,
                checkFirmwareStart: action.params.checkFirmwareStart,
                reloadAPPage: action.params.reloadAPPage,
                status: DEVICE_CHECK_FIRMWARE
            }
        case DEVICE_FWUPGRADE_ACK:
            return {
                ...state,
                firmUpdAckTimestamp: action.params.firmUpdAckTimestamp,
                status: DEVICE_FWUPGRADE_ACK
            }
        case DO_DEVICE_SITE_SURVEY:
            return {
                ...state,
                status: DO_DEVICE_SITE_SURVEY,
                popLoading: true
            }
        case DO_DEVICE_SITE_SURVEY_SUCCESS:
                return {
                ...state,
                status: DO_DEVICE_SITE_SURVEY_SUCCESS,
                popLoading: true
        }
        case DO_DEVICE_SITE_SURVEY_FAIL:
            return {
                ...state,
                status: DO_DEVICE_SITE_SURVEY_FAIL,
                popLoading: false
            }
        case GET_DEVICE_SITE_SURVEY_DATA:
            return {
                ...state,
                status: GET_DEVICE_SITE_SURVEY_DATA,
                wifiList: action.params.wifiList,
                wifiList1: action.params.wifiList1,
                wifiWithRogue: action.params.wifiWithRogue,
                wifi1WithRogue: action.params.wifi1WithRogue,
                rogueAll: action.params.rogueAll,
                popLoading: false
            }

        // ethernet
        case GET_DEVICE_ETHERNET:
            return {
                ...state,
                status: GET_DEVICE_ETHERNET,
                deviceEthernetList: []                
            }
        case GET_DEVICE_ETHERNET_SUCCESS:
            return {
                ...state,
                status: GET_DEVICE_ETHERNET_SUCCESS,
                deviceEthernetList: action.params.deviceEthernetList,
                selectTemplate: action.params.selectTemplate,
                selectEthernet: action.params.selectEthernet
            }
        case SELECT_DEVICE_ETHERNET:
            const selectEthernet = action.params.selectEthernet;
            let selectTemplate = null;
            deviceEthernetList.forEach(deviceEthernet => {
                if (deviceEthernet.seq + '' === selectEthernet + '') {                    
                    selectTemplate = deviceEthernet.templateSeq;
                    deviceDetail.template = selectTemplate;
                }
            });

            return {
                ...state,
                status: SELECT_DEVICE_ETHERNET,
                selectTemplate: selectTemplate,
                selectEthernet: selectEthernet,
                deviceDetail: deviceDetail
            }

        // parameter
        case GET_DEVICE_PARAMETER_DATA:
            return {
                ...state,
                status: GET_DEVICE_PARAMETER_DATA,
                monitorColumnsConfig: action.params.monitorColumnsConfig,
                // abnormalColumnsConfig: action.params.abnormalColumnsConfig,
                // managerColumnsConfig: action.params.managerColumnsConfig
            }

        case DL_DEVICE_GROUP_CONFIG: 
            return {
                ...state,
                status: DL_DEVICE_GROUP_CONFIG,
                downlinkExecuteResult: action.params.executeResult
            }

        case GET_PROFILE_RADIO_SETTING_INFO_SUCCESS:
            return {
                ...state,
                status: GET_PROFILE_RADIO_SETTING_INFO_SUCCESS,
                channelSettingInfo: action.params.channelSettingInfo,
                txpowerSettingInfo: action.params.txpowerSettingInfo
            }
        case GET_PROFILE_RADIO_SETTING_INFO_FAIL:
            return {
                ...state,
                status: GET_PROFILE_RADIO_SETTING_INFO_FAIL,
                errMsg: action.params.errMsg
            }
        case GET_DEVICE_MAC_WHITE_LIST:
            return {
                ...state,
                status: GET_DEVICE_MAC_WHITE_LIST,
                macWhiteList: null
            }
        case GET_DEVICE_MAC_WHITE_LIST_SUCCESS:
            return {
                ...state,
                status: GET_DEVICE_MAC_WHITE_LIST_SUCCESS,
                macWhiteList: action.params.macWhiteList
            }
        case GET_DEVICE_MAC_WHITE_LIST_FAIL:
            return {
                ...state,
                status: GET_DEVICE_MAC_WHITE_LIST_FAIL,
                errMsg: action.params.errMsg
            }
        case UPDATE_DEVICE_MAC_WHITE_LIST:
            return {
                ...state,
                status: UPDATE_DEVICE_MAC_WHITE_LIST,
                macWhiteList: null
            }
        case UPDATE_DEVICE_MAC_WHITE_LIST_SUCCESS:
            return {
                ...state,
                status: UPDATE_DEVICE_MAC_WHITE_LIST_SUCCESS,
                macWhiteList: action.params.macWhiteList
            }
        case UPDATE_DEVICE_MAC_WHITE_LIST_FAIL:
            return {
                ...state,
                status: UPDATE_DEVICE_MAC_WHITE_LIST_FAIL,
                errMsg: action.params.errMsg
            }
        case CHECK_IS_EXIST_MAC_WHITE_LIST:
            return {
                ...state,
                status: CHECK_IS_EXIST_MAC_WHITE_LIST,
                isExistInMacWhiteList: null,
                loading: true
            }
        case CHECK_IS_EXIST_MAC_WHITE_LIST_SUCCESS:
            return {
                ...state,
                status: CHECK_IS_EXIST_MAC_WHITE_LIST_SUCCESS,
                isExistInMacWhiteList: action.params.isExistInMacWhiteList,
                loading: false
            }
        case CHECK_IS_EXIST_MAC_WHITE_LIST_FIAL:
            return {
                ...state,
                status: CHECK_IS_EXIST_MAC_WHITE_LIST_FIAL,
                errMsg: action.params.errMsg,
                loading: false
            }
        case GET_SWITCH_DETAIL_INFO:
            return {
                ...state,
                status: GET_SWITCH_DETAIL_INFO,
                switchDetailPort: null,
                switchDetailNeighbor: null,
                errMsg: null,
                loading: true
            }
        case GET_SWITCH_DETAIL_INFO_SUCCESS:
            return {
                ...state,
                status: GET_SWITCH_DETAIL_INFO_SUCCESS,
                switchDetailPort: action.params.switchDetailPort,
                switchDetailNeighbor: action.params.switchDetailNeighbor,
                errMsg: null,
                loading: false
            }
        case GET_SWITCH_DETAIL_INFO_FAIL:
            return {
                ...state,
                status: GET_SWITCH_DETAIL_INFO_FAIL,
                switchDetailPort: null,
                switchDetailNeighbor: null,
                errMsg: action.params.errMsg,
                loading: false
            }
            case EDIT_SWITCH:
                return {
                    ...state,
                    status: EDIT_SWITCH,
                    errMsg: null,
                    loading: true
                }
            case EDIT_SWITCH_SUCCESS:
                return {
                    ...state,
                    status: EDIT_SWITCH_SUCCESS,
                    errMsg: null,
                    loading: false
                }
            case EDIT_SWITCH_FAIL:
                return {
                    ...state,
                    status: EDIT_SWITCH_FAIL,
                    errMsg: action.params.errMsg,
                    loading: false
                }
            case DO_SAVE_USED_PROFILE:
                return {
                    ...state,
                    status: DO_SAVE_USED_PROFILE
                }
            case DO_SAVE_USED_PROFILE_SUCCESS:
                return {
                    ...state,
                    status: DO_SAVE_USED_PROFILE_SUCCESS
                }
            case DO_SAVE_USED_PROFILE_FAIL:
                return {
                    ...state,
                    status: DO_SAVE_USED_PROFILE_FAIL
                }
        default:
            return state;
    }
};

const deviceReducers = (
    state = {
        errMsg: null,
        status: WAIT_INIT_DEVICE,
        deviceList: [],
        deviceReadyToAdd: [],
        deviceConnected: null,
        orderList: [],
        abnormalColumnsConfig: null,
        deviceTemplateList: [],
        deviceEthernetList: [],
        selectTemplate: null,
        deviceDetail: null,
        showDeviceDetail: false,
        deviceDetailLoading: false,
        loading: true,
        profileNetList: null,
        profileRadioList: null,
        profileVapList: null,
        popLoading: false,
        deviceStatusUpdatTimestamp: null,
        resolveData: null,
        info: null,
        confirm: false,
        deviceEthernetData: null,
        deviceNetworkInfo: null,
        deviceRadioInfo: null,
        deviceVapInfo: null,
        deleteVapInfo: null,
        selectedDevice: null,
        macWhiteList:null,
        isExistInMacWhiteList:null,
        wifiList: null,
        wifiList1: null,
        wifiWithRogue: null,
        wifi1WithRogue: null,
        rogueAll: null
    },
    action
) => {
    switch (action.type) {
        default:
            return doAction(state, action);
    }
};

export default deviceReducers